// Applique les réglages de contrôles (épaisseur de bordure, remplissage des
// champs de formulaire) en custom properties CSS sur :root — tailwind.config.js
// lit ces mêmes variables (border-control, bg-input) avec un repli identique au
// rendu d'origine (1px, et `sand` opaque) tant qu'elles ne sont pas définies,
// exactement comme applyPalette.js/applyShape.js/applySpacing.js. `controls`
// est la réponse DÉJÀ RÉSOLUE du backend (get_theme_controls :
// {controls, resolved, options}) — jamais recalculée ici.
//
// Le remplissage est une OPACITÉ et non une couleur : le fond des champs suit
// ainsi la palette de la boutique (rôle `sand`), y compris après une
// personnalisation des couleurs. Une couleur en dur ici cesserait de suivre.
export default function applyControls(controls) {
  const resolved = controls?.resolved;
  if (!resolved) return;
  const root = document.documentElement;
  if (resolved.border_width) root.style.setProperty("--border-width", resolved.border_width);
  if (resolved.input_fill_alpha !== undefined && resolved.input_fill_alpha !== null) {
    root.style.setProperty("--input-fill-alpha", String(resolved.input_fill_alpha));
  }
}
